<script setup>
defineProps({
  id: {
    type: String,
    required: true,
  },
  // Vuelidate formatted errors
  errors: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <p
    v-if="errors.length"
    :id="id"
    aria-live="assertive"
    class="mt-2 text-sm text-red-600">
    <span
      v-for="error in errors"
      :key="error.$uid"
      class="block">
      {{ error.$message }}
    </span>
  </p>
</template>
